import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "hidden", "plus", "minus" ];

  toggle() {
    if (this.hiddenTarget.classList.contains("hidden")) {
      this.hiddenTarget.classList.remove("hidden");
      this.minusTarget.classList.remove("hidden");
      this.plusTarget.classList.add("hidden");
    } else {
      this.hiddenTarget.classList.add("hidden");
      this.minusTarget.classList.add("hidden");
      this.plusTarget.classList.remove("hidden");
    }
  }
}
